/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FocusDay } from '../../models/focus-day';

export interface CreateInitiativeFocusDay$Params {
  initiativeId: string;
      body?: FocusDay
}

export function createInitiativeFocusDay(http: HttpClient, rootUrl: string, params: CreateInitiativeFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<FocusDay>> {
  const rb = new RequestBuilder(rootUrl, createInitiativeFocusDay.PATH, 'post');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FocusDay>;
    })
  );
}

createInitiativeFocusDay.PATH = '/initiative/{initiativeId}/focusday';
